import { render, staticRenderFns } from "./newReports.vue?vue&type=template&id=49dea2e2"
import script from "./newReports.ts?vue&type=script&lang=js&external"
export * from "./newReports.ts?vue&type=script&lang=js&external"
import style0 from "./newReports.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports